import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { map } from 'rxjs/operators';

import { IUser, User } from '@app/core';
import { environment } from '@env/environment';

@Injectable({
  providedIn: 'root',
})
export class UserService {
  constructor(private http: HttpClient) {}

  isEmailExists(email: string) {
    return this.http.get<any>(`${environment.apiUrl}users/check_email/`, {
      params: { email },
      headers: { 'silent-loader': 'true' },
    });
  }

  isUsernameExists(username: string) {
    return this.http.get<any>(`${environment.apiUrl}users/check_username/`, {
      params: { username },
      headers: { 'silent-loader': 'true' },
    });
  }

  getRoles() {
    return this.http.get<any>(`${environment.apiUrl}groups/`);
  }

  getStatuses() {
    const statuses = [
      { id: false, name: 'Inactive' },
      { id: true, name: 'Active' },
    ];

    return of(statuses);
  }

  getEmailVerificationStatuses() {
    const statuses = [
      { id: false, name: 'Pending' },
      { id: true, name: 'Verified' },
    ];

    return of(statuses);
  }

  getUsers(
    filters: HttpParams | { [params: string]: string | string[] } = {},
    isSilentLoader = false
  ) {
    return this.http
      .get<any>(`${environment.apiUrl}users/`, {
        params: filters,
        headers: { 'silent-loader': isSilentLoader ? 'true' : 'false' },
      })
      .pipe(map(res => ({ ...res, results: res.results.map((user: IUser) => new User(user)) })));
  }

  updateUser(user: IUser): Observable<User> {
    return this.http
      .patch<any>(`${environment.apiUrl}users/${user.id}/`, user)
      .pipe(map((user: IUser) => new User(user)));
  }

  deleteUser(id: number) {
    return this.http.delete<any>(`${environment.apiUrl}users/${id}/`);
  }

  getInstructorsUsers() {
    return this.http.get<any>(`${environment.apiUrl}users/instructor_list/`, {
      headers: { 'silent-loader': 'true' },
    });
  }

  updateUserPassword(id: number, user): Observable<User> {
    return this.http
      .patch<any>(`${environment.apiUrl}users/${id}/admin_change_password`, user)
      .pipe(map((user: IUser) => new User(user)));
  }
}
